import React from 'react';
import Layout from '../components/Layout';
import TruckList from '../components/TruckList';

/**
 * Página de listado de camiones
 * Utiliza el componente Layout para mantener la estructura consistente
 * y el componente TruckList para mostrar la lista de camiones
 */
const Trucks = () => {
  return (
    <Layout>
      <div>
        <TruckList />
      </div>
    </Layout>
  );
};

export default Trucks;
